export const getHostname = () => {
  const hostname = window.location.hostname
  const [domain, type] = hostname.split('.').slice(-2)
  const subdomain = hostname.replace(`${domain}.${type}`, '').slice(0, -1)

  return { subdomain, domain, type, hostname }
}
